import {post} from '@/utils/request';
import {erpserver,oaserver,erpplatserver} from '@/utils/baseUrl';


// 查询费用
export async function getFees(params) {
    return post(erpserver+'/purchaseinvoice/getFees', params, true);
}
// 查询订单
export async function getOrderList(params) {
    return post(erpserver+'/purchaseinvoice/getOrderList', params, true);
}
// 查询关联付款申请
export async function getGlFksq(params) {
    return post(erpserver+'/purchaseinvoice/getGlFksq', params, true);
}
// 查询关联订单
export async function getGlOrder(params) {
    return post(erpserver+'/purchaseinvoice/getGlOrder', params, true);
}
//查询发票cwlist
export async function cwlist(params) {
    return post(erpserver+'/purchaseinvoice/cwlist', params, true);
}
//shenhe
export async function approved(params) {
    return post(erpserver+'/purchaseinvoice/approved', params, true);
}
//shenhe
export async function returned(params) {
    return post(erpserver+'/purchaseinvoice/returned', params, true);
}
// 查询付款申请
export async function fksq(params) {
    return post(erpserver+'/purchaseinvoice/fksq', params, true);
}

//上传图片
export async function upload(params) {
    return post(erpplatserver+'/system/uploadFile',params,false);
}
//根据开票方获取发票编号列表-获取详情
export async function beforedetail(params) {
    return post(erpserver+'/purchaseinvoice/beforedetail', params, true);
}
//根据开票方获取发票编号列表
export async function beforehandle(params) {
    return post(erpserver+'/purchaseinvoice/beforehandle', params, true);
}
//发票类型
export async function fplx(params) {
    return post(erpserver+'/purchaseinvoice/fplx', params, true);
}
//详情
export async function detail(params) {
    return post(erpserver+'/purchaseinvoice/detail', params, true);
}
//品种
export async function pzlist(params) {
    return post(erpserver+'/purchaseinvoice/pzlist', params, true);
}
//销售方
export async function getKhByKz(params) {
    return post(erpserver+'/purchaseinvoice/getKhByKz', params, true);
}
//保存
export async function save(params) {
    return post(erpserver+'/purchaseinvoice/save', params, true);
}

//查询开票类型
export async function fptype(params) {
    return post(erpserver+'/purchaseinvoice/fptype', params, true);
}
//查询开票方（客户
export async function getkhlist(params) {
    return post(erpserver+'/purchaseinvoice/getkhlist', params, true);
}
// 获取公司
export async function getCompanyList(params) {
    //return post(erpserver+'/purchaseinvoice/getgslist', params, true);
    return post(erpserver+'/currency/getCompanyList', params, true);
}
// 查询订单
export async function getOrders(params) {
    return post(erpserver+'/purchaseinvoice/getOrders', params, true);
}
// 品名匹配
export async function convertUnit(params) {
    return post(erpserver+'/purchaseinvoice/convertUnit', params, true);
}
// 单位换算
export async function convertUnitNew(params) {
    return post(erpserver+'/purchaseinvoice/convertUnitNew', params, true);
}
//
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}

